<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 
-->
<template>
  <div class="lc-rower">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LcRower',
  data() {
    return {};
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>
